import React from "react";
import { Box, Skeleton } from "@mui/material";

const TableSkeleton = ({ rows = 10, columns = 5, rowHeight = 40 }) => (
  <Box sx={{ width: "100%", borderRadius: 2, overflow: "hidden", border: 1, borderColor: "grey.200" }}>
    {/* Table header skeleton */}
    <Box
      sx={{
        display: "flex",
        bgcolor: "grey.200",
        px: 1,
        py: 1,
        borderBottom: 2,
        borderColor: "grey.300",
        boxShadow: 1,
      }}
    >
      {Array.from({ length: columns }).map((_, idx) => (
        <Box
          key={idx}
          sx={{
            flex: 1,
            mx: 0.5,
            minWidth: 60,
            height: rowHeight * 0.8,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Skeleton
            variant="text"
            width="60%"
            height={rowHeight * 0.6}
            sx={{
              bgcolor: "grey.400",
              borderRadius: 1,
            }}
          />
        </Box>
      ))}
    </Box>
    {/* Table rows skeleton */}
    {Array.from({ length: rows }).map((_, rowIdx) => (
      <Box
        key={rowIdx}
        sx={{
          display: "flex",
          bgcolor: rowIdx % 2 === 0 ? "grey.50" : "background.paper",
          px: 1,
          py: 0.75,
        }}
      >
        {Array.from({ length: columns }).map((_, colIdx) => (
          <Skeleton
            key={colIdx}
            variant="rectangular"
            width="100%"
            height={rowHeight * 0.7}
            sx={{
              flex: 1,
              mx: 0.5,
              borderRadius: 1,
              minWidth: 60,
            }}
          />
        ))}
      </Box>
    ))}
  </Box>
);

export default TableSkeleton;
